// Your web app's Firebase configuration
export const firebaseConfig = {
	apiKey: "AIzaSyCf0vf7DRullhyXY1Q6WAg9Cn8vsDm1vzA",
	authDomain: "bus-stop-system.firebaseapp.com",
	projectId: "bus-stop-system",
	storageBucket: "bus-stop-system.appspot.com",
	messagingSenderId: "762483722497",
	appId: "1:762483722497:web:5627a269295de3d18cb300",
    databaseURL: "https://bus-stop-system-default-rtdb.europe-west1.firebasedatabase.app"
};